/* Monique Beauty — theme scripts (ingen afhængigheder) */
(function () {
  "use strict";

  var money = function (cents) {
    var v = (cents / 100).toLocaleString("da-DK", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return v + " kr";
  };

  /* ---------------- Mobil-navigation ---------------- */
  function initNav() {
    var burger = document.querySelector("[data-nav-toggle]");
    var nav = document.querySelector("[data-nav]");
    if (burger && nav) {
      burger.addEventListener("click", function () {
        var open = nav.classList.toggle("is-open");
        burger.setAttribute("aria-expanded", open ? "true" : "false");
      });
    }
    document.querySelectorAll("[data-dropdown-toggle]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        if (window.innerWidth > 767) return;
        e.preventDefault();
        var item = btn.closest(".mb-nav__item");
        if (item) item.classList.toggle("is-open");
      });
    });
  }

  /* ---------------- Accordion ---------------- */
  function initAccordions(scope) {
    (scope || document).querySelectorAll("[data-accordion-trigger]").forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = "1";
      btn.addEventListener("click", function () {
        var panel = btn.parentElement.querySelector("[data-accordion-panel]");
        var open = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", open ? "false" : "true");
        if (panel) panel.classList.toggle("mb-accordion__panel--open", !open);
      });
    });
  }

  /* ---------------- Slider ---------------- */
  function initSliders(scope) {
    (scope || document).querySelectorAll("[data-slider]").forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = "1";
      var track = root.querySelector("[data-slider-track]");
      var slides = track ? Array.prototype.slice.call(track.children) : [];
      if (!track || !slides.length) return;

      var dots = root.querySelectorAll("[data-slider-dot]");
      var prev = root.querySelector("[data-slider-prev]");
      var next = root.querySelector("[data-slider-next]");
      var index = 0;

      function perView() {
        var w = root.offsetWidth;
        var basis = parseFloat(getComputedStyle(slides[0]).width);
        return Math.max(1, Math.round(w / (basis + 24)));
      }
      function maxIndex() { return Math.max(0, slides.length - perView()); }
      function go(i) {
        index = Math.min(Math.max(i, 0), maxIndex());
        var slideW = slides[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
        track.style.transform = "translateX(-" + index * (slideW + gap) + "px)";
        dots.forEach(function (d, di) { d.setAttribute("aria-selected", di === index ? "true" : "false"); });
      }
      if (prev) prev.addEventListener("click", function () { go(index - 1); });
      if (next) next.addEventListener("click", function () { go(index + 1); });
      dots.forEach(function (d, di) { d.addEventListener("click", function () { go(di); }); });
      window.addEventListener("resize", function () { go(index); });
      go(0);
    });
  }

  /* ---------------- Kurv-drawer ---------------- */
  var Cart = {
    open: function () {
      document.querySelector("[data-cart-drawer]") && document.querySelector("[data-cart-drawer]").classList.add("is-open");
      document.querySelector("[data-cart-overlay]") && document.querySelector("[data-cart-overlay]").classList.add("is-open");
      document.body.style.overflow = "hidden";
    },
    close: function () {
      document.querySelector("[data-cart-drawer]") && document.querySelector("[data-cart-drawer]").classList.remove("is-open");
      document.querySelector("[data-cart-overlay]") && document.querySelector("[data-cart-overlay]").classList.remove("is-open");
      document.body.style.overflow = "";
    },
    refresh: function () {
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "?section_id=cart-drawer" : "/?section_id=cart-drawer")
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.querySelector("[data-cart-drawer-contents]");
          var current = document.querySelector("[data-cart-drawer-contents]");
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          return fetch("/cart.js").then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll("[data-cart-count]").forEach(function (el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? "grid" : "none";
          });
          bindCartLines();
          return cart;
        })
        .catch(function () {});
    },
    add: function (id, qty) {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return Cart.refresh(); })
        .then(function () { Cart.open(); });
    },
    change: function (key, qty) {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { return Cart.refresh(); });
    }
  };
  window.MBCart = Cart;

  function bindCartLines() {
    document.querySelectorAll("[data-line-change]").forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = "1";
      btn.addEventListener("click", function () {
        Cart.change(btn.dataset.lineKey, parseInt(btn.dataset.lineQty, 10));
      });
    });
    document.querySelectorAll("[data-line-remove]").forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = "1";
      btn.addEventListener("click", function () { Cart.change(btn.dataset.lineKey, 0); });
    });
  }

  function initCart() {
    document.querySelectorAll("[data-cart-open]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); Cart.open(); });
    });
    document.querySelectorAll("[data-cart-close]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); Cart.close(); });
    });
    document.addEventListener("keyup", function (e) { if (e.key === "Escape") Cart.close(); });
    bindCartLines();
  }

  /* ---------------- Produktside: bundles + galleri ---------------- */
  function initProduct() {
    // Galleri
    document.querySelectorAll("[data-gallery]").forEach(function (gal) {
      var main = gal.querySelector("[data-gallery-main]");
      gal.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          if (main) main.src = thumb.dataset.full;
          gal.querySelectorAll("[data-gallery-thumb]").forEach(function (t) { t.setAttribute("aria-current", "false"); });
          thumb.setAttribute("aria-current", "true");
        });
      });
    });

    // Bundle-valg
    document.querySelectorAll("[data-bundle]").forEach(function (group) {
      var options = group.querySelectorAll("[data-bundle-option]");
      var form =
        document.querySelector(group.dataset.bundleForm || "[data-product-form]") ||
        document.querySelector("form[action$='/cart/add']");
      function select(opt) {
        options.forEach(function (o) { o.setAttribute("aria-checked", "false"); });
        opt.setAttribute("aria-checked", "true");
        if (form) {
          var input = form.querySelector("[name='id']");
          if (input) input.value = opt.dataset.variantId;
          var qty = form.querySelector("[name='quantity']");
          if (qty && opt.dataset.quantity) qty.value = opt.dataset.quantity;
        }
      }
      options.forEach(function (opt) {
        opt.addEventListener("click", function () { select(opt); });
        var cta = opt.querySelector("[data-bundle-cta]");
        if (cta) {
          cta.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            select(opt);
            if (!opt.dataset.variantId) return;
            Cart.add(parseInt(opt.dataset.variantId, 10), parseInt(opt.dataset.quantity || "1", 10));
          });
        }
      });
      if (options.length) select(options[0]);
    });

    // Variant-vælgere (standard)
    document.querySelectorAll("[data-variant-select]").forEach(function (sel) {
      sel.addEventListener("change", function () {
        var form = sel.closest("form");
        if (!form) return;
        var input = form.querySelector("[name='id']");
        if (input) input.value = sel.value;
        var priceEl = document.querySelector("[data-variant-price]");
        var opt = sel.options[sel.selectedIndex];
        if (priceEl && opt && opt.dataset.price) priceEl.textContent = money(parseInt(opt.dataset.price, 10));
      });
    });

    // Ajax add-to-cart
    var forms = document.querySelectorAll("[data-product-form], form[action$='/cart/add']");
    forms.forEach(function (form) {
      if (form.dataset.mbBound) return;
      form.dataset.mbBound = "1";
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var id = form.querySelector("[name='id']");
        var qty = form.querySelector("[name='quantity']");
        if (!id || !id.value) return;
        Cart.add(parseInt(id.value, 10), qty ? parseInt(qty.value, 10) : 1);
      });
    });
  }

  /* ---------------- Nedtælling ---------------- */
  function initCountdown() {
    document.querySelectorAll("[data-countdown]").forEach(function (el) {
      var target = new Date(el.dataset.countdown).getTime();
      if (isNaN(target)) return;
      function tick() {
        var diff = Math.max(0, target - Date.now());
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var set = function (k, v) {
          var n = el.querySelector("[data-cd-" + k + "]");
          if (n) n.textContent = v < 10 ? "0" + v : v;
        };
        set("days", d); set("hours", h); set("minutes", m); set("seconds", s);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------------- Kopiér rabatkode ---------------- */
  function initCopy() {
    document.querySelectorAll("[data-copy]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var text = btn.dataset.copy;
        if (navigator.clipboard) navigator.clipboard.writeText(text);
        var old = btn.getAttribute("aria-label");
        btn.setAttribute("aria-label", "Kopieret");
        setTimeout(function () { btn.setAttribute("aria-label", old || "Kopiér"); }, 1600);
      });
    });
  }

  function boot() {
    initNav();
    initAccordions();
    initSliders();
    initCart();
    initProduct();
    initCountdown();
    initCopy();
  }

  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);

  // Shopify theme editor
  document.addEventListener("shopify:section:load", function (e) {
    initAccordions(e.target);
    initSliders(e.target);
    initProduct();
    initCountdown();
  });
})();
